var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "footer",
    { staticClass: "layout-footer", attrs: { "data-cy": "footer" } },
    [
      _c(
        "div",
        { staticClass: "links", attrs: { "data-cy": "footer-links" } },
        [
          _c(
            "div",
            { staticClass: "content" },
            _vm._l(_vm.links, function(link) {
              return _c(
                link.external ? "a" : "router-link",
                {
                  key: link.name,
                  tag: "component",
                  staticClass: "link",
                  class: link.is_divider_link ? "link-divider" : "",
                  attrs: {
                    href: link.path || null,
                    target: link.external ? "_blank" : "",
                    to: link.path
                  }
                },
                [_vm._v("\n        " + _vm._s(link.name) + "\n      ")]
              )
            }),
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bottom" }, [
        _c(
          "div",
          { staticClass: "terms", attrs: { "data-cy": "footer-terms" } },
          _vm._l(_vm.terms, function(term) {
            return _c(
              "router-link",
              {
                key: term.name,
                staticClass: "term",
                attrs: { to: { name: term.name } }
              },
              [_vm._v("\n        " + _vm._s(term.routeName) + "\n      ")]
            )
          }),
          1
        ),
        _vm._v(" "),
        !_vm.hideDeveloped
          ? _c(
              "div",
              { staticClass: "copyright" },
              [
                _c("c-clube-logo", {
                  staticClass: "logo",
                  attrs: { "is-grey": "" }
                }),
                _vm._v(" "),
                _c("p", { staticClass: "copyright-symbol" }, [
                  _vm._v(
                    "\n        © " +
                      _vm._s(new Date().getFullYear()) +
                      "\n      "
                  )
                ])
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("c-button", {
        class: _vm.classes,
        attrs: { alternative: "", size: "xl", icon: "chevron-up" },
        on: { click: _vm.scrollTop }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f220956c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f220956c","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout/LayoutFooter.vue
// module id = 2147
// module chunks = 1610